<template lang="pug">
.content
  h2.titulo-the-home Bem-Vindo ao módulo de relatórios!
  el-row.cards-mod(
    type="flex",
    justify="center",
    :gutter="30"
  )
    el-col.card-mod(
      v-for="funcionalidade in menu",
      :key="funcionalidade.codigo",
      @click.native="redirecionaFuncionalidade(funcionalidade.routeName)",
    )
      el-card.center
        div.center(slot="header")
          img.func-card(:src='imgFuncionalidades(funcionalidade.img)')
        span {{ funcionalidade.nome }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters({
      menu: 'menu/menu'
    })
  },

  methods: {
    redirecionaFuncionalidade (route) {
      this.$router.push({
        name: route
      })
    },

    imgFuncionalidades (img) {
      return 'static/' + img
    }
  }
}
</script>

<style lang="scss" scoped>

  .content {
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
    display: inline;
    align-items: center;
    align-content: center;
    justify-content: center;
    .cards-mod {
      margin: 0 !important;
      display: flex;
      flex-wrap: wrap;
      * {
        width: fit-content;
        flex-wrap: wrap;
      }
    }

    .card-mod {
      height: 299px;
      width: 268px;
      flex-wrap: wrap;
      cursor: pointer;
      margin-bottom: 30px;
      text-align: center;
      word-wrap:  normal;

      > :hover{
        transform: scale(1.05);
        transition-property: 2s;
      }
    }

    .card-mod-disabled {
      height: 299px;
      width: 268px;
      flex-wrap: wrap;
      cursor: pointer;
      margin-bottom: 30px;
      text-align: center;
      word-wrap:  normal;
      opacity: 0.7;
    }

    .center {
      width: 100%;
      height: 100%;
    }

    .func-card {
      width: 180px;
      height: 180px;
    }

    .titulo-the-home {
      padding: 10px;
      h1, h2 {
        font-size: 1.2em;
        font-weight: normal;
      }
      text-align: center;
    }
    color:#666674 !important;
  }

  @media (max-width: 1365px) {
    .content {
      .cards-mod {
      display: flex;
      align-items: center;
      justify-content: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/Home.vue